/* Petal Post: "Add a little extra" offer in the cart page and cart drawer, shown below the checkout button.
   Also shows a short note above checkout explaining the one delivery-or-pickup choice, made at checkout.
   To add another extra, create it as an unlisted Add-on product and add its handle to HANDLES. */
(function () {
  if (window.__ppCartX) return;
  window.__ppCartX = true;
  var HANDLES = ['teddy-bear', 'balloon', 'rose-petals'];
  var cart = null, products = null, timer = null, busy = false;

  function money(c) { var d = c / 100; return '$' + (Math.round(d) === d ? d.toFixed(0) : d.toFixed(2)); }
  function esc(s) {
    return String(s).replace(/[&<>"]/g, function (ch) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[ch]; });
  }

  var st = document.createElement('style');
  st.textContent =
    '.pp-xtras{margin:1.2rem 0 1.4rem;padding:1.2rem 0 .4rem;border-top:1px solid rgba(var(--color-foreground),.12)}' +
    '.pp-x-title{margin:0 0 .8rem;font-size:1.4rem;font-weight:600;text-align:center}' +
    '.pp-x-card{display:flex;align-items:center;gap:.8rem;margin:.6rem 0;font-size:1.3rem}' +
    '.pp-x-name{flex:1}' +
    '.pp-x-card select{padding:.5rem;font:inherit;border:1px solid rgba(var(--color-foreground),.35);background:transparent;color:inherit;max-width:13rem}' +
    '.pp-x-card .button{min-height:3.4rem;min-width:7rem;padding:0 1.2rem;margin:0}' +
    '.pp-modenote{margin:0 0 1.2rem;padding:1rem 1.2rem;font-size:1.3rem;line-height:1.45;text-align:center;border:1px solid rgba(var(--color-foreground),.25);border-radius:2px}';
  document.head.appendChild(st);

  function cardHtml(p) {
    var vs = (p.variants || []).filter(function (v) { return v.available; });
    if (!vs.length) return '';
    var control;
    if (vs.length > 1) {
      control = '<select class="pp-x-sel" aria-label="' + esc(p.title) + ' option">' +
        vs.map(function (v) { return '<option value="' + v.id + '">' + esc(v.title) + ' (' + money(v.price) + ')</option>'; }).join('') + '</select>';
    } else {
      control = '<span class="pp-x-price">' + money(vs[0].price) + '</span>';
    }
    return '<div class="pp-x-card"><span class="pp-x-name">' + esc(p.title) + '</span>' + control +
      '<button type="button" class="button button--secondary pp-x-add" data-vid="' + vs[0].id + '">Add</button></div>';
  }
  function build() {
    var cards = products.map(cardHtml).join('');
    return cards ? '<div class="pp-xtras"><p class="pp-x-title">Add a little extra</p>' + cards + '</div>' : '';
  }
  function modeNote() {
    return 'At checkout, choose <strong>Ship</strong> to have it delivered (we price it by distance), or <strong>Pick up</strong> to collect it free from Canada Bay.';
  }
  function apply() {
    if (!cart) return;
    var show = cart.item_count > 0;
    var note = show ? modeNote() : '';
    document.querySelectorAll('.cart__ctas').forEach(function (box) {
      var n = box.parentNode.querySelector('.pp-modenote');
      if (note) {
        if (!n) {
          n = document.createElement('p');
          n.className = 'pp-modenote';
          box.parentNode.insertBefore(n, box);
        }
        if (n.dataset.k !== note) { n.innerHTML = note; n.dataset.k = note; }
      } else if (n) {
        n.remove();
      }
      if (!products || !products.length) return;
      var ex = box.parentNode.querySelector('.pp-xtras');
      if (!show) { if (ex) ex.remove(); return; }
      if (ex) return;
      var html = build();
      if (html) box.insertAdjacentHTML('afterend', html);
    });
  }
  function loadProducts() {
    return Promise.all(HANDLES.map(function (h) {
      return fetch('/products/' + h + '.js').then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; });
    })).then(function (list) {
      products = list.filter(function (p) { return p && p.variants && p.variants.length; });
    });
  }
  function loadCart() {
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) { cart = c; apply(); })
      .catch(function () {});
  }
  function schedule() { clearTimeout(timer); timer = setTimeout(loadCart, 300); }

  document.addEventListener('click', function (e) {
    var b = e.target && e.target.closest ? e.target.closest('.pp-x-add') : null;
    if (!b || busy) return;
    e.preventDefault();
    var card = b.closest('.pp-x-card');
    var sel = card && card.querySelector('.pp-x-sel');
    var vid = Number(sel ? sel.value : b.getAttribute('data-vid'));
    if (!vid) return;
    busy = true;
    b.disabled = true;
    var drawer = b.closest('cart-drawer');
    var body = { items: [{ id: vid, quantity: 1 }] };
    if (drawer && drawer.getSectionsToRender) {
      body.sections = drawer.getSectionsToRender().map(function (s) { return s.id; }).join(',');
      body.sections_url = window.location.pathname;
    }
    fetch(window.routes.cart_add_url + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    })
      .then(function (r) { return r.json(); })
      .then(function (resp) {
        if (resp.status) { b.disabled = false; return; }
        if (drawer && drawer.renderContents) {
          var first = (resp.items && resp.items[0]) || {};
          drawer.renderContents({ key: first.key, id: first.id, sections: resp.sections });
        } else {
          window.location.reload();
        }
      })
      .catch(function () { b.disabled = false; })
      .then(function () { busy = false; schedule(); });
  });

  function start() {
    loadProducts().then(loadCart);
    if (window.MutationObserver) {
      new MutationObserver(function (list) {
        for (var i = 0; i < list.length; i++) {
          var n = list[i].target;
          if (n && n.closest && (n.closest('.pp-xtras') || n.closest('.pp-modenote'))) continue;
          schedule();
          return;
        }
      }).observe(document.body, { childList: true, subtree: true });
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
